<script setup lang="ts">
import { computed, ref, watch } from "vue";
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

const props = defineProps<{
  question: Question;
}>();

const emit = defineEmits<{
  (event: "submitted", value: string): void;
}>();

const answer = ref("");
const submitted = ref(false);

const isCorrect = computed(() => answer.value.trim() === String(props.question.correct).trim());

watch(
  () => props.question.id,
  () => {
    answer.value = "";
    submitted.value = false;
  },
);

function submitAnswer() {
  if (submitted.value) {
    return;
  }

  submitted.value = true;
  emit("submitted", answer.value.trim());
}
</script>

<template>
  <div class="space-y-4">
    <pre v-if="question.code" class="overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>{{ question.code }}</code></pre>

    <div>
      <label class="block text-xs font-semibold uppercase tracking-wide text-slate-500" for="code-answer">
        Predict output
      </label>
      <input
        id="code-answer"
        v-model="answer"
        type="text"
        class="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-sky-400"
        placeholder="Apna answer likho"
        :disabled="submitted"
      >
    </div>

    <button
      type="button"
      class="rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white"
      :disabled="submitted || !answer.trim()"
      @click="submitAnswer"
    >
      Check Answer
    </button>

    <div v-if="submitted" class="rounded-2xl bg-slate-50 p-4 text-sm">
      <p class="font-semibold" :class="isCorrect ? 'text-emerald-700' : 'text-rose-700'">
        {{ isCorrect ? "Correct" : "Incorrect" }}
      </p>
      <p class="mt-1 text-slate-700">Actual output: <span class="font-semibold text-slate-900">{{ question.correct }}</span></p>
      <p class="mt-2 text-slate-700">{{ question.explanation }}</p>
    </div>
  </div>
</template>
